import {
  Box,
  Typography,
  IconButton,
  Popper,
  ClickAwayListener,
} from "@mui/material";
import React, { useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { getFileName } from "../../utils/getFileIcon";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ArticleIcon from "@mui/icons-material/Article"; // DOC icon
import DescriptionIcon from "@mui/icons-material/Description"; // For CSV
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import ImageIcon from "@mui/icons-material/Image";
import { useState, } from "react";

const FetchFilesBrsr = ({
  Uploadkey,
  setFormData,
  setUploadedFiles,
  fileUrls,
}) => {
  const firstRemarkRef = useRef(null);
  const popperArrowRef = useRef(null);
  const [showRemark, setShowRemark] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const [clickedIndex, setClickedIndex] = useState(null);
  const [arrowOffset, setArrowOffset] = useState(0);
  const [verticalOffset, setVerticalOffset] = useState(0);
  const [popperVerticalOffset, setPopperVerticalOffset] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const anchorRefs = useRef([]);

  const handleDeleteDocument = (value, index) => {
    console.log(value, index, "value, index");
    setFormData((prev) => ({
      ...prev,
      [Uploadkey]: prev[Uploadkey].filter((file, idx) => file !== value),
    }));
    setUploadedFiles((prev) => ({
      ...prev,
      [Uploadkey]: prev[Uploadkey]?.filter((file, idx) => file !== value),
    }));
    // setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  const getFileIcon = (fileName = "") => {
    const lowerFileName = fileName.toLowerCase();

    if (lowerFileName.includes("pdf")) {
      return (
        <PictureAsPdfIcon
          sx={{ color: "red", fontSize: "30px", marginRight: "5px" }}
        />
      );
    }

    if (lowerFileName.includes("docx") || lowerFileName.includes("doc")) {
      return (
        <ArticleIcon
          sx={{ color: "blue", fontSize: "30px", marginRight: "5px" }}
        />
      );
    }

    if (
      lowerFileName.includes("xlsx") ||
      lowerFileName.includes("xls") ||
      lowerFileName.includes("sheet")
    ) {
      return (
        <DescriptionIcon
          sx={{ color: "green", fontSize: "30px", marginRight: "5px" }}
        />
      );
    }

    if (
      lowerFileName.includes("jpg") ||
      lowerFileName.includes("jpeg") ||
      lowerFileName.includes("png") ||
      lowerFileName.includes("gif") ||
      lowerFileName.includes("svg") ||
      lowerFileName.includes("webp")
    ) {
      return (
        <ImageIcon
          sx={{ color: "purple", fontSize: "30px", marginRight: "5px" }}
        />
      );
    }

    return (
      <TextSnippetOutlinedIcon sx={{ fontSize: "30px", marginRight: "5px" }} />
    );
  };

  return (
    <Box
      sx={{
        border: "none !important",
        display: "inline",
        pt: 0,
      }}
    >
      <Typography
        sx={{
          color: "#8F8F8F",
          fontFamily: "inter",
          fontWeight: 600,
          fontSize: "16px",
          lineHeight: "24px",
        }}
      >
        Documents
      </Typography>
      {fileUrls?.length > 0 && (
        <Box mb={2} sx={{ mt: 2 }}>
          <Box display="flex" flexWrap="wrap" gap={1.5}>
            {fileUrls.map((fileUrl, index) => {
              const fileExtension = fileUrl?.document.split(".").pop();
              const fileName = getFileName(fileUrl?.document);

              return (
                <Box
                  sx={{
                    marginTop: "0px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "1rem",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      key={index}
                      sx={{
                        position: "relative",
                        display: "flex",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        backgroundColor: "#f9f9f9",
                        overflowX: "hidden",
                        width: "5.5rem",
                        minWidth: "5.5rem",
                        maxWidth: "5.5rem",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          // alignItems: "center",
                          flexDirection: "column",
                          padding: 1,
                          width: "100%",
                        }}
                      >
                        <Box sx={{ width: "100%", textAlign: "center" }}>
                          {getFileIcon(fileExtension)}
                        </Box>
                        <Typography
                          variant="caption"
                          sx={{
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                            overflow: "hidden",
                            textAlign: "center",
                            width: "100%", // fixed width as you wanted
                            // lineHeight: "1.2em", // controls line height
                            maxHeight: "3.5em", // 1.2em * 3 lines
                            padding: "0px",
                            wordBreak: "break-word",
                            minHeight: "3.5rem",
                          }}
                        >
                          {fileName}
                        </Typography>
                      </Box>

                      <IconButton
                        onClick={() => handleDeleteDocument(fileUrl, index)}
                        sx={{
                          position: "absolute",
                          top: "0",
                          right: "0",
                          color: "white",
                          backgroundColor: "rgba(0,0,0,0.5)",
                          width: "20px",
                          height: "20px",
                          "&:hover": {
                            backgroundColor: "rgba(0,0,0,0.7)",
                          },
                        }}
                      >
                        <CloseIcon sx={{ fontSize: "10px" }} />
                      </IconButton>
                    </Box>
                  </Box>
                  <Box
                    ref={index === 0 ? firstRemarkRef : null}
                    onClick={(event) => {
                      setShowRemark(true);
                      setSelectedRemark(index);
                      setClickedIndex(index);
                      setAnchorEl(event.currentTarget);
                      
                      // Calculate the offset from the first button
                      if (firstRemarkRef.current && event.currentTarget) {
                        const firstButtonRect = firstRemarkRef.current.getBoundingClientRect();
                        const clickedButtonRect = event.currentTarget.getBoundingClientRect();
                        const horizontalOffset = clickedButtonRect.left - firstButtonRect.left;
                        
                        // Calculate which line the button is on (9 documents per line)
                        const lineNumber = Math.floor(index / 9);
                        const calculatedPopperOffset = lineNumber * 200; // Assuming 80px height per line
                        
                        // For arrow positioning, use actual DOM position
                        const actualVerticalOffset = clickedButtonRect.top - firstButtonRect.top;

                        console.log(actualVerticalOffset,calculatedPopperOffset,"check1",lineNumber)
                        
                        setArrowOffset(horizontalOffset);
                        setVerticalOffset(actualVerticalOffset);
                        setPopperVerticalOffset(calculatedPopperOffset);
                      }
                    }}
                    sx={{
                      maxWidth: 300,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      fontSize: "14px",
                      fontWeight: 500,
                      fontFamily: "inter",
                      mt: 1,
                      mb: 2,
                      color: "#1C486B",
                      textDecoration: "underline",
                      cursor: "pointer",
                      display: "inline-block",
                    }}
                  >
                    View Remark
                  </Box>

                  {/* Popper with local arrow ref */}
                  {showRemark &&
                    <Popper
                      open={showRemark}
                      anchorEl={firstRemarkRef.current}
                      placement="bottom-start"
                      style={{ 
                        // position: 'fixed',
                        position:"absolute",
                        zIndex: 999,
                        width: "70%",
                        minWidth: "70%",
                        maxWidth: "70%",
                        marginBottom: "1rem",
                        marginTop:`${verticalOffset}px`,
                        top:`${verticalOffset}px`
                        // transform: `translateY(${popperVerticalOffset}px)`
                      }}
                      modifiers={[
                        {
                          name: "arrow",
                          enabled: true,
                        },
                        {
                          name: "offset",
                          options: {
                            offset: [0, 10],
                          },
                        },
                        {
                          name: "preventOverflow",
                          options: {
                            boundary: 'viewport',
                            padding: 8,
                          },
                        },
                      ]}
                    >
                      <ClickAwayListener onClickAway={() => {
                        setShowRemark(false);
                        setClickedIndex(null);
                        setArrowOffset(0);
                        setVerticalOffset(0);
                        setPopperVerticalOffset(0);
                        setAnchorEl(null);
                      }}>
                        <Box
                          sx={{
                            p: 1,
                            bgcolor: "white",
                            boxShadow: 3,
                            borderRadius: 1,
                            mb: 2,
                            position: "relative"
                          }}
                        >
                          {/* ARROW ELEMENT */}
                          <Box
                            ref={popperArrowRef}
                            sx={{
                              position: "absolute",
                              top: verticalOffset > 0 ? `${verticalOffset - 6}px` : "-6px",
                              left: `${20 + arrowOffset}px`,
                              width: 0,
                              height: 0,
                              borderLeft: "6px solid transparent",
                              borderRight: "6px solid transparent",
                              borderBottom: "6px solid white",
                            }}
                          />
                          <Typography
                            variant="body2"
                            sx={{ wordWrap: "break-word" }}
                          >
                            {fileUrls[clickedIndex]?.remarks || "No remark added"}
                          </Typography>
                        </Box>
                      </ClickAwayListener>
                    </Popper>
                  }
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default FetchFilesBrsr; 